var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IndexInvoices',{key:_vm.$route.fullPath,attrs:{"countryID":_vm.countryID}})}
var staticRenderFns = []

export { render, staticRenderFns }